import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import './system-logs.css';

const columns = [
  { id: 'date', label: 'Date:Time', minWidth: 170 },
  { id: 'username', label: 'username', minWidth: 100 },
  { id: 'status', label: 'status', minWidth: 100 },
  {
    id: 'event',
    label: 'event',
    minWidth: 170,
    align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
];

function createData(date, username, event, status) {
  return { date, username, event, status };
}

const rows = [
  createData('12-15-2023 22:11:23', 'zuhaib', 'Authentication Failed', 'false'),
  createData('15-18-2023 11:11:23', 'zuhaib', 'Created the lab "Lab Test 1"', 'true'),
  createData('17-13-2023 19:11:23', 'majid', 'Authentication Failed', 'false'),
  createData('18-13-2023 12:11:23', 'harry', 'Stopped "VM 1" in "Lab Test 1"', 'true'),
  createData('15-18-2023 11:11:23', 'jon', 'Failed to delete VM 1 of Lab 12', 'false'),
  createData('17-13-2023 13:11:23', 'jon', 'Stopped "VM 2" in "Lab 10"', 'true'),
  createData('13-18-2023 09:11:23', 'majid', 'Deleted "VM 1" in "Lab Test 1"', 'true'),
  //
  createData('12-15-2023 22:11:23', 'zuhaib', 'Authentication Failed', 'false'),
  createData('13-14-2023 21:11:23', 'zuhaib', 'Logged into EVOS', 'true'),
  createData('17-13-2023 19:11:23', 'majid', 'Authentication Failed', 'false'),
  createData('13-14-2023 21:11:23', 'zuhaib', 'Login failed into EVOS', 'false'),
  createData('18-13-2023 12:11:23', 'harry', 'Stopped "VM 1" in "Lab Test 1"', 'true'),
  createData('17-13-2023 13:11:23', 'jon', 'Stopped "VM 2" in "Lab 10"', 'true'),
  createData('13-18-2023 09:11:23', 'majid', 'Deleted "VM 1" in "Lab Test 1"', 'true'),
  //
  createData('12-15-2023 22:11:23', 'zuhaib', 'Authentication Failed', 'false'),
  createData('13-14-2023 21:11:23', 'zuhaib', 'Logged into EVOS', 'true'),
  createData('15-18-2023 11:11:23', 'jon', 'Created the lab "Lab Test 1"', 'true'),
  createData('17-13-2023 19:11:23', 'majid', 'Authentication Failed', 'false'),
  createData('18-13-2023 12:11:23', 'harry', 'Stopped "VM 1" in "Lab Test 1"', 'true'),
  createData('17-13-2023 13:11:23', 'jon', 'Stopped "VM 2" in "Lab 10"', 'true'),
  createData('13-18-2023 09:11:23', 'majid', 'Deleted "VM 1" in "Lab Test 1"', 'true'),
  // //
];

export default function StickyHeadTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(14);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: '100vh' }}>
        <Table stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <>
                  {column.id !== 'status' ? (
                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ) : (
                    ''
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => { */}
            {rows.map((row) => {
              return (
                <TableRow hover role='checkbox' tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    if (column.id !== 'status') {
                      return (
                        <>
                          <TableCell className={row.status} key={column.id} align={column.align}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                          </TableCell>
                        </>
                      );
                    }
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[14, 25, 100]}
        component='div'
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
    </Paper>
  );
}
